// Generated by Melange


function make_client_functions(param) {
  return [
    param[0].to_proto,
    param[1].from_proto
  ];
}

function make_service_functions(param) {
  return [
    param[0].from_proto,
    param[1].to_proto
  ];
}

export {
  make_client_functions,
  make_service_functions,
}
/* No side effect */
